<template>
    <div class="google-map-wrapper"
         :style="heightObject()">
        <div class="google-map"
             id="google-map"
             ref="googleMap">
        </div>
        <template v-if="Boolean(google) && Boolean(map) && Boolean(googleMapApi) && Boolean(address) && Boolean(title)">
            <slot :title="title"
                  :google="google"
                  :map="map"
                  :google-map-api="googleMapApi"
                  :address="address">
            </slot>
        </template>
    </div>
</template>

<script>
import { Loader } from '@googlemaps/js-api-loader';
import MapSettings from "../../../helpers/mapSettings";

export default {
    name: "design-2021-apprentice-google-map-component",
    props: {
        title: {
            type: String,
            required: true,
        },

        googleMapApi: {
            type: String,
            required: true,
        },

        address: {
            type: Object,
            required: true,
        },

        height: {
            type: Number,
            required: true,
        }
    },

    data(){
        return {
            apiKey: this.googleMapApi,
            google: null,
            map: null,
            geocoder: null,
            GeocodeSettings: {
                lat: 0,
                lng: 0,
            },
        }
    },

    async mounted() {
        const loader = new Loader({
            apiKey: this.apiKey,
            version: "weekly",
            libraries: ["places"],
            language: "nl-NL",
        });

        await loader.load();
        this.google = google;
        const mapContainer = this.$refs.googleMap;
        const geocoderPromise = this. setGeoLocationSettings();

        geocoderPromise.then(
            () => {
              this.map = new this.google.maps.Map(mapContainer, this.config());
            }
        );
    },

    methods: {
        async setGeoLocationSettings() {
          const address = `${this.address.street} ${this.address.number}, ${this.address.zipcode} ${this.address.location}`;

          this.geocoder = new this.google.maps.Geocoder();

          await this.geocoder.geocode({
                address: address,
            }, (results, status) => {
                if (status === 'OK') {
                    this.GeocodeSettings.lat = results[0].geometry.location.lat();
                    this.GeocodeSettings.lng = results[0].geometry.location.lng();
                }
            }
          );
        },

        config() {
          MapSettings.center = this.GeocodeSettings;

          return MapSettings;
        },

        heightObject(){
            return {
                height: `${this.height}px`
            }
        }
    },
}

</script>

<style scoped lang="scss">
    .google-map {
        width: 100%;
        min-height: 100%;
    }

</style>
